import * as types from "../../constants";
import { BillItem, Billable, BillableCombo } from "../../pages/hospital/Billing/types";
import { TYPE_BILL_ITEM } from "../../constants/types";
import { reconcileAnaesthesiaItems } from "../../utils/bill";
/**
 * Reducer that saves all the investigations loaded
 * @constructor
 * @param {boolean} state 
 */

export interface BillingReducer{
    data:{
        billItems:BillItem[] | null,
        billableCombos:BillableCombo[] | null,
        billablesCurrentBill:Billable[] | null,
        billables:Billable[] | null
    },
    loading:boolean,
    error:null | string
}
 const initialState = {
    data: {
        //bills:null,
        billables:null,
        billablesCurrentBill:null,
        billableCombos:null,
        billItems:null
    },
    loading: false,
    error: null
}
 
export default function reducer(state:BillingReducer = initialState, action:any){

    let newState = { ...state};

    let currentBillItems;
    let currentBillables;

    switch(action.type){
        case types.FETCH_BILLING_LOADING:
            newState.loading = true;
            newState.error = null;
            return newState;
        case types.SAVE_BILL_ITEMS:
            // SHER-342: keep the derived anaesthesia lines in step on every item write.
            newState.data.billItems = reconcileAnaesthesiaItems([...action.billItems])
            newState.loading = initialState.loading; 
            newState.error = initialState.error;   
            return newState;
        case types.RESET_BILL_ITEMS:
            newState.data.billItems = [];
            newState.loading = initialState.loading;
            newState.error = initialState.error;
            return newState;
        case types.PUSH_BILL_ITEMS:
            currentBillItems = newState.data.billItems ? newState.data.billItems : [];
            newState.data.billItems = reconcileAnaesthesiaItems([...currentBillItems,...action.billItems])
            newState.loading = initialState.loading;
            newState.error = initialState.error;
            return newState;
        case types.GET_BILLABLES_SUCCESS:
        case types.UPDATE_BILLABLES_SUCCESS:
            newState.data.billablesCurrentBill = action.billables;
            newState.loading = false; 
            newState.error = null; 
            return newState;     
        case types.GET_BILLABLE_COMBO_SUCCESS:
            newState.data.billableCombos = action.billableCombos;
            newState.loading = false;
            newState.error = null;
            return newState;
        case types.PUSH_BILLABLES:
            currentBillItems = newState.data.billItems ? newState.data.billItems : [];
            currentBillables = newState.data.billablesCurrentBill ? newState.data.billablesCurrentBill : [];
            console.log("currentBillables",currentBillables);
            
            // Calculate the next order number
            const maxOrder = currentBillItems.length > 0 
                ? Math.max(...currentBillItems.map(item => item.order || 0))
                : 0;
            let nextOrder = maxOrder + 1;
            
            for(let i = 0; i < action.billablesId.length; i++){
                const billableId = action.billablesId[i];
                console.log("BillableId",billableId);
                const indexBillable = currentBillables.findIndex((b:Billable) => b.id === billableId.id);
                console.log("indexBillable",indexBillable);
                if( indexBillable !== -1){
                    const currentBillable = currentBillables[indexBillable];
                    let conceptText = currentBillable.concept;
                    
                    // Apply package numbering for package type billables
                    if(currentBillable.type === TYPE_BILL_ITEM.PACKAGE) {
                        // Count existing package items of the same billable
                        const existingPackageItems = currentBillItems.filter(item => 
                            item.billableId === billableId.id && 
                            item.type === TYPE_BILL_ITEM.PACKAGE
                        );
                        
                        // Calculate package number (existing count + 1)
                        const packageNumber = existingPackageItems.length + 1;
                        
                        // Remove any existing number at the end of the concept text
                        conceptText = conceptText.replace(/\s+\d+$/, '');
                        
                        // Add package number to concept
                        conceptText = `${conceptText} ${packageNumber}`;
                    }
                    
                    const currentBillItem = {
                        ...currentBillable, 
                        concept: conceptText,
                        quantity: 1, 
                        unitCost: currentBillable.amount, 
                        updatedAt: new Date(), 
                        billableId: billableId.id, 
                        order: nextOrder++
                    };
                    delete currentBillItem.id;
                    currentBillItems.push(currentBillItem);
                }
            }
            newState.data.billItems = reconcileAnaesthesiaItems([...currentBillItems])
            newState.loading = initialState.loading;
            newState.error = initialState.error;
            return newState;
        case types.GET_BILLABLES_ERROR:
            newState.loading = false;
            newState.error = 'Error fetching billables';
            return newState;
        case types.INITIALIZE_BILLING:
            newState.data = action.payload;
            return newState;
        default:
            return state;
    }
}